<!-- eslint-disable -->
<template>
  <g>
    <defs>
      <clipPath id="mask-rounded">
        <circle cx="50%" cy="50%" r="50%" fill="#ffffff" />
      </clipPath>
    </defs>
    <image
      :xlink:href="url"
      :width="width"
      :height="height"
      clip-path="url(#mask-rounded)"
    />
  </g>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null
    },
    width: {
      type: [String, Number],
      default: 32
    },
    height: {
      type: [String, Number],
      default: 32
    }
  }
};
</script>
